import { useQuery } from '@tanstack/react-query';

import { apiFetchJson } from '../../lib/apiFetch.js';
import type { EmployeeWeekEntriesResponse } from './contractsMirror.js';

/**
 * The signed-in person's OWN shifts for the current week.
 *
 * NO `employeeId` IS SENT, and that is the point. `GET /api/v1/timesheets` resolves the acting
 * employee from the session — for the Employee role it ignores a supplied id outright, and for
 * everybody else it falls back to the caller's own linked employee record when none is given. The
 * SPA cannot send an id anyway: `GET /api/v1/me` returns none.
 *
 * ⚠ A user with NO linked employee record gets `400 employee_required`. That is a real state, not a
 * fault — an office account that has never been an employee has no timesheet — so the caller must
 * render the failure as "nothing to show" rather than as a broken screen.
 *
 * The key nests under `['timesheets']` so every punch mutation's existing
 * `invalidateQueries({ queryKey: ['timesheets'] })` refreshes it. A punch changes what this returns.
 */
export const MY_WEEK_QUERY_KEY = ['timesheets', 'mine', 'week'] as const;

export function useMyWeekQuery(enabled: boolean) {
  return useQuery<EmployeeWeekEntriesResponse>({
    queryKey: MY_WEEK_QUERY_KEY,
    queryFn: () => apiFetchJson<EmployeeWeekEntriesResponse>('/api/v1/timesheets'),
    enabled,
  });
}
